import { createActions } from '~/store/utils';

const { Types, Actions } = createActions({
  // saml
  USERNAME_LOGIN_REQUEST: null,
  USERNAME_LOGIN_SUCCESS: null,
  USERNAME_LOGIN_FAILURE: null,
  USERNAME_LOGIN_ERROR: null,
  // username/password
  PASSWORD_LOGIN_REQUEST: null,
  PASSWORD_LOGIN_SUCCESS: null,
  PASSWORD_LOGIN_FAILURE: null,
  PASSWORD_LOGIN_ERROR: null,
  PASSWORD_LOGIN_RESET: null,

  SET_USERNAME: null,
  CLEAR_LOGIN: null,
});

export { Actions, Types };
